import { create } from 'zustand';

interface TaskUiState {
  /** Задача, открытая в панели редактирования. */
  editorTaskId: string | null;
  openTaskEditor: (taskId: string) => void;
  closeTaskEditor: () => void;
}

/**
 * Глобальное UI-состояние списков задач:
 * одна панель редактирования для всех экранов (списки + архив).
 */
export const useTaskUiStore = create<TaskUiState>((set) => ({
  editorTaskId: null,
  openTaskEditor: (taskId) => {
    set({ editorTaskId: taskId });
  },
  closeTaskEditor: () => {
    set({ editorTaskId: null });
  },
}));
